import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RowClickedEvent } from 'ag-grid-community';
import { UserService } from 'src/app/_services/user.service';
import Swal from 'sweetalert2';
import { CustomerService } from '../../../customers/customer-service';
import { MerchantService } from '../merchant.service';
import { environment } from 'src/environments/environment';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
const {defaultCountry} = environment;
@Component({
  selector: 'app-merchant-screening',
  templateUrl: './merchant-screening.component.html',
  styleUrls: ['./merchant-screening.component.scss']
})
export class MerchantScreeningComponent implements OnInit {

   @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  public permissions: any;
  reviewFlag : any;
  isInitiateKycFlag : boolean ;
  isSubmittedKycFlag : boolean;
  saveReviewFlag:any;
  merchantFullName :any;
  merchantUserId :any;
  merchantMobile : any;
  merchantEnableClass : any = "contact selected";
  modalConfigReport: ModalConfig;
  image: any;
  mindatadis: boolean = true;
  loading: boolean = false;

  profileData :any
  addedBy:any
  customerForm: FormGroup
  Resultdata: any;
  param1: any;
  fname: any;
  mobile: any
  emailId: any
  eid: any
  emiratesExpiry: any
  edcMobile: any
  nationality: any
  dob: any
  gender: any
  passportNumber: any
  passportType: any
  passportExpiry: any
  occupation: any
  pob: any
  emirate: any
  poBox: any
  city: any
  areaDesc: any


  relavent : any;
  notRelavent :any;
  remark:any;
  finalRelavency : any


  status: any
  remarkData: any

  mid: any
  userId: any
  entityType :any = "Merchant";

  emiratesIdImage: any
  screeningReportPdf: any



  // Customer Profile Variables 
  screeningId : any
  fullname : any
  IdenfoGender : any
  dateOfBirth :any
  countryOfResidence:any
  residenceStatus : any 
  recordLastUpdated: any
  user: any
  deliveryChannel : any

  //Customer Name Screening Variables
  sanctionHit: boolean
  sanctionHitClass : any
  sanctionHitColor : any

  pepHit: boolean
  pepHitClass: any
  pepHitColor:any

  specialInterestHit: boolean
  specialInterestHitClass: any
  specialInterestHitColor: any

  adverseMediaHit: boolean
  adverseMediaHitClass: any
  adverseMediaHitColor: any

  selfDeclaredHit: boolean
  selfDeclaredHitClass: any
  selfDeclaredHitColor: any

  riskRatingHit: any
  riskRatingHitClass: any
  riskRatingHitColor: any

  enforcementHit: any
  enforcementHitClass: any
  enforcementHitColor: any

  isSelfPepHit: any
  isSelfPepHitClass: any
  isSelfPepHitColor: any


  //Risk Factor
  countryOfResidenceRisk : any
  countryOfResidenceScore : any
  countryOfResidenceLevel : any

  deliveryChannelRisk : any
  deliveryChannelScore : any
  deliveryChannelLevel: any

  industryRisk: any
  industryScore: any
  industryLevel :any

  nationalityRisk: any
  nationalityScore: any
  nationalityLevel: any

  productRisk: any
  productScore: any
  productLevel: any

  stateRisk: any
  stateScore: any
  stateLevel: any

  baseRatingRisk: any


  suspiciousActivityReportsRisk: any
  suspiciousActivityReportsScore: any
  suspiciousActivityReportsLevel: any

  nonResidentRisk: any
  nonResidentScore: any
  nonResidentLevel: any

  residenceCountryIsSanctionedRisk: any
  residenceCountryIsSanctionedScore: any
  residenceCountryIsSanctionedLevel: any


  nameScreeningHitSanction : String[]
  nameScreeningHitPep : Boolean
  nameScreeningHitSpecialInterest : any
  nameScreeningHitAdverseMedia : Boolean
  nameScreeningHitDetermination: String

  sanctionScore : any;
  sanctionLevel : any;
  baseRatingLevel : any
  overAllRating :any

  datatableDob: any
  datatableNationality : any
  
  na : any

  nameScreeningHitsLength: number;
  nameScreeningHitsData: any;
  associations : any[];
  mediaData : any[];
  fieldsData : any[];
  screeningConfig : any = {
    matchScore:0,
    rcaSearch: false,
    aliasSearch: false,
    searchList: []
  };
  onboardedBy : any;

  nameScreeningRemarkData :any;
  nameScreeningRemarkLength : any;
  nameScreeningRelevant: any;
  nameScreeningComments: any;

  map : Map<string, any>;
  isShowInitiate :  boolean;
  saveFlag:boolean;
  keywordList : any[];
  dummyImage : any = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRD4FE0yuWmNBJVLqgk1zdrR8yqqGaD-ixsbDcAfreV44qN5dKgBU3F6OgpIwEYBVs2RWI&usqp=CAU";
  UBOList : any[];
  @Input() mobileNumber: String = "";
  selectedTab: number=2;

  constructor(private router: Router,private modalService : NgbModal,private customerOldService: MerchantService, private route: ActivatedRoute, private domSanitizer: DomSanitizer,private alertService : AlertService,private userService:UserService,private menuService: MenusService,private location:Location,private customerService : CustomerService) {

  }
  async ngOnInit() {

    this.isInitiateKycFlag = false;
    this.isSubmittedKycFlag = false;
    this.isShowInitiate = false;
    this.saveFlag = false;
    this.nameScreeningHitsData = [];
    this.modalConfigReport = {
      modalTitle: "Shareholder/Owner/UBO Screening Report",
      modalSize: 'xl',
      css : "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.userService.getUserProfileNew().subscribe((data) => {
      this.addedBy = data.fullName;
    }); 
    this.merchantUserId = this.route.snapshot.queryParamMap.get("mid");
    this.merchantMobile = this.route.snapshot.queryParamMap.get("mobile");
    this.setScreeningData(this.route.snapshot.queryParamMap.get("mobile"),this.route.snapshot.queryParamMap.get("mid"),"MERCHANT");

    this.fetchUBOList();
  }
  activeTab = 'customerProfile'; // Default active tab
  activeTabSub='profile';


  switchTab(tab: string): void {
    this.activeTab = tab;
    this.tableVisible = true;
  }

  namePoints : any
  scoreObjectRes : any
  openScoreBreakdown(content: any,row:any,scoreObject : any) {
    console.log("Content Row : "+row);

    this.scoreObjectRes = scoreObject;
    
    console.log("Score Object"+this.namePoints);

    this.selectedRow = row;
    this.modalService.open(content, { centered: true });
    
  }

  switchTabSub(tab: string): void {
    this.activeTabSub = tab;
    this.tableVisible = false;
  }

  rowSelectProfile(item:any, nameScreeningHitsLength: Number){
    console.log("Item :"+item);
    console.log("Which row :"+nameScreeningHitsLength);
  }

  tableVisible: boolean = false; // Initially set to true to show the table

  isGenuine: boolean = false;
  isRelevant: boolean = true;
  selectedRow : number
  extraInfoObject: any ;

  toggleTableVisibility(param: RowClickedEvent | any,row : any) {
    this.tableVisible = !this.tableVisible; // Toggle visibility
    console.log("Row Clicked", param);
    console.log("Fullname : "+JSON.stringify(this.nameScreeningHitsData[row]));
    console.log("Which row selected : "+row);
    this.selectedRow = row;
    console.log("Extra Info :"+JSON.stringify(this.nameScreeningHitsData[this.selectedRow].screeningData.extra_info));
    
    this.extraInfoObject = this.nameScreeningHitsData[this.selectedRow].screeningData.extra_info;
    console.log("Extra Info :"+JSON.stringify(this.extraInfoObject));
    console.log("Designation  : "+this.nameScreeningHitsData[this.selectedRow].screeningData.role_type);
    this.associations = this.nameScreeningHitsData[row].associates;
    console.log("Associations : "+JSON.stringify(this.associations));
    this.mediaData = this.nameScreeningHitsData[row].media;
    console.log("Media : "+JSON.stringify(this.mediaData));
    this.fieldsData = this.nameScreeningHitsData[row].fields;
    console.log("Fields : "+JSON.stringify(this.fieldsData));
    for(let i:number = 0; i<this.fieldsData.length;i++){
      console.log(this.fieldsData[i]);
      for (let key in this.fieldsData[i]) {
        console.log(key);
      }
    }
  
    
  }
  
  saveRemarks(item: any, length: any) {  
    const radioElement = document.querySelector('input[name="nshRadio' + length + '"]:checked') as HTMLInputElement;
    const relevancy = radioElement ? radioElement.value : null;
  
    const remarksElement = document.querySelector('input[name="remark' + length + '"]') as HTMLInputElement;
    const remarks = remarksElement ? remarksElement.value : null;
  
    if (remarks === "" || remarks === null || remarks.trim() === "") {
      this.alertService.toastErrorMessageAlert({titleText:"Remarks field is required"})
      return;
    }
  
    if (relevancy === null || relevancy === "") {
      this.alertService.toastErrorMessageAlert({titleText:"Relevancy field is required"})
      return; 
    }
  
    if (this.saveFlag) {
      const saveRemarkIcon = document.getElementById('saveRemarkIcon' + length);
      if (saveRemarkIcon) {
        saveRemarkIcon.setAttribute('data-disabled', 'true');
      }
  
      console.log("Relavancy: " + relevancy);
      console.log("Comment: " + remarks);
  
      let requestForm = {
        "screeningId": this.screeningId,
        "mobileNumber": this.mid,
        "relevancy": relevancy,
        "remark": remarks,
        "referenceId": item._id,
        "addedBy": this.addedBy
      };
  
      this.customerService.saveNameScreeningRemark(requestForm).subscribe((data: any) => {
        console.log("Response" + JSON.stringify(data));
        if (data.response.message === "Name Screening Remark saved successfully") {
          Swal.fire('Name Screening Remark saved successfully', '', 'success');
          this.customerService.getCustomerNameScreeningById(this.screeningId).subscribe((res: any) => {
            console.log("Name Screening Remark Length : "+res.response.data.length);
            this.getSavedNameScreeningLength=res.response.data.length;
          });
        } else {
          Swal.fire('Error while saving Name Screening Remark', '', 'error');
        }
      });
    } else {
      console.log("No data to be saved for name screening remark");
    }
  }
  

  saveActivityTimeline(screeningId:any,fullname:any,narration:any,type:any,addedBy:any){
    let requestForm ={
      "screeningId" : screeningId,
      "fullName" : fullname,
      "narration" : narration,
      "type" : type,
      "addedBy" : addedBy,
  }
 
    this.customerService.saveActivityTimeline(requestForm).subscribe((data) => {
      console.log("Response" + JSON.stringify(data));
      // this.alertService.successAlert(data);
    
    }
    );
  

  }

  selectUBOTab(data:any,row:number){
    this.entityType = "Shareholder/Owner/UBO";
    console.log(row)
    console.log(data)
    this.fname = data.shareHolderName;
    this.setScreeningData(data.mobileNumber,data.id,"UBO");
    this.merchantEnableClass = "contact";
    this.UBOList.map((_:any)=>{
      _.uboEnableClass = "contact";
    })
    this.UBOList[row].uboEnableClass = "contact selected";
  }

  merchantSelect(){
    this.entityType = "Merchant";
    console.log("Merchant Selected");
    this.setScreeningData(this.merchantMobile,this.merchantUserId,"MERCHANT");
    this.merchantEnableClass = "contact selected";
    this.UBOList.map((_:any)=>{
      _.uboEnableClass = "contact";
    })
  }
  updateReviewKycFlag(flag:any,userId:any){
    this.customerService.updateReviewFlag(flag,userId).subscribe((data) => {
      console.log("updateReviewFlag" +data);
      this.ngOnInit();
      this.selectedTab = 2;
    }
    );

  }

  kycComment:any
  selectedStatus: any
  narrationKyc:any
  typeKyc:any
  userType :any;
    
  submitKycReview(){
    console.log("Status :"+this.selectedStatus);
    console.log("Comment :"+this.kycComment);

    if(this.selectedStatus!=undefined && this.kycComment!=undefined && this.kycComment!= ""){
      if(this.reviewFlag==0 || this.reviewFlag==1 ){
        this.userType = "L1 (Maker)";
      }
      else{
        this.userType = "L2 (Checker)";
      }
      console.log("Review Flag : "+this.reviewFlag);
      if(this.selectedStatus == "ACCEPTED" && this.reviewFlag==3){
        let statusChangeRequest = {
          "userId" : this.userId,
          "status" : "APPROVED", 
          "remark" : this.kycComment
        }
        this.customerService.updateCustomerKycStatusChange(statusChangeRequest).subscribe((data) => {
          console.log(data);
        });
      }else if(this.selectedStatus == "REJECTED" && this.reviewFlag==3){
        let statusChangeRequest = {
          "userId" : this.userId,
          "status" : "REJECTED", 
          "remark" : this.kycComment
        }
        this.customerService.updateCustomerKycStatusChange(statusChangeRequest).subscribe((data) => {
          console.log(data);
        });

      }
    this.narrationKyc = this.userType+" Submitted Screening Review Status and changed KYC Status to "+this.selectedStatus+" with the following comment : "+this.kycComment,
    
    this.typeKyc = "System Generated";

    this.updateReviewKycFlag(this.saveReviewFlag,this.userId);
    this.saveActivityTimeline(this.screeningId,this.fullname,this.narrationKyc,this.typeKyc,this.addedBy);
    this.modalService.dismissAll();
    this.alertService.successAlert("Screening Review Submitted Succsessfully");
    }
  }

  get isMaxLengthExceeded(): boolean {
    return this.kycComment.length > 255;
  }

  toggleTableVisibility1(){
    this.tableVisible = !this.tableVisible;
  }


keys(): Array<string> { 
  if(this.extraInfoObject){
    return Object.keys(this.extraInfoObject); 
  }else{
    return []
  }
} 

keyword(obj : any): Array<string> { 
  console.log(JSON.parse(obj));
  if(obj)
    console.log(Object.keys(JSON.parse(obj)));
  
  if(obj){
    return Object.keys(JSON.parse(obj)); 
  }else{
    return []
  }
} 



  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }

  getIconFromString(val: String){

    // console.log(val);
    if(val == "sanction"){
      return "feather icon-x-circle";
    }else{
    return "feather icon-check";
    }
  }

  getIconFromBoolean(val: String){

    // console.log(val);
    if(val =="true"){
      return "feather icon-x-circle";
    }else{
    return "feather icon-check";
    }
  }
  
  getIconFromStringCondition(val: String){

    // console.log(val);
    if(val == "false"){
      return "feather icon-check";
    }else{
    return "feather icon-x-circle";
    }
  }
 
  toggleRelevance(isRelevant: boolean) {
    this.isRelevant = isRelevant;
  }

  toggleGenuine() {
    this.isGenuine = !this.isGenuine;
  }

  getSavedNameScreeningLength:any;
  showInitiatePop(cont: any){
    this.modalService.open(cont, { centered: true });

  }
  showKycPop(cont:any){

    if(this.getSavedNameScreeningLength==this.nameScreeningHitsLength){
      this.modalService.open(cont, { centered: true });
    }else{
      Swal.fire('Please select relevancy for all alerts before submitting the review.',"", 'warning');
    }
  }


  narration:any
  type:any
  userType1:any;
  
  showInitiate(cont: any){

    
    this.type = "System Generated";
    if(this.reviewFlag==0 || this.reviewFlag==1 ){
      this.userType1 = "L1 (Maker)";
    }else{
      this.userType1 = "L2 (Checker)";
    }
    this.narration = "Initiated "+this.userType1+" Review Process";

    this.updateReviewKycFlag(this.saveReviewFlag,this.userId);
    this.saveActivityTimeline(this.screeningId,this.fullname,this.narration,this.type,this.addedBy)
    this.modalService.dismissAll(cont);
    // this.isShowInitiate=true;
    // console.log("name screening length : "+this.nameScreeningHitsLength);
    // for (let i = 0; i < this.nameScreeningHitsLength; i++) {
    //   debugger   
    //   const saveRemarkIcon = document.getElementById('saveRemarkIcon' + i);   
    //   if (saveRemarkIcon) {      
    //      saveRemarkIcon.setAttribute('data-disabled', 'false'); 
    //     }
    // }
  }
  hideInitiate(){
    this.isShowInitiate=false;
  }

  activityLength :any
  activityData :any
  reversedList: Array<any> = [];

  getActivityTimeline(screeningId:any){
    this.customerService.getCustomerActivityById(screeningId).subscribe((data:any) => {
      console.log("Activity Response" + JSON.stringify(data));
      this.activityLength = data.response.data.length;
      console.log("activityLength" + this.activityLength);
      this.activityData = data.response.data;
      this.reversedList = this.activityData.slice().reverse();
      
      
      // console.log("activityLengthData" + this.activityData[0].addedBy);
      
    
    }
    );

  }

  getFormattedDate(epochMilli:any) {
    var d = new Date(0);
    d.setUTCMilliseconds(epochMilli);
    // console.log(d.toISOString().slice(0,10))
    return d.toISOString().slice(0,10)
  }
  
  showKeywordModal(cont:any,keyword : any){
    var dummmy = keyword[0];
    this.keywordList = [];
    console.log(dummmy);
    this.keywordList = dummmy.split(",");
    console.log(this.keywordList);
    this.modalService.open(cont, { centered: true });
  }

  fetchUBOList(){
    this.customerOldService.getUBO(this.userId).subscribe((response:any)=>{
          console.log(response);
          this.UBOList = response.response.data.data;
          this.UBOList.map((_:any)=>{
            _.uboEnableClass = "contact";
          })
    });
  }


  setScreeningData(mobileNumber : any,userId:any,userType : any){
    this.mid = mobileNumber;
    this.userId = userId;
    this.isInitiateKycFlag = false;
    this.isSubmittedKycFlag = false;
    this.isShowInitiate = false;
    this.saveFlag = false;
    this.nameScreeningHitsData = [];
    this.customerService.getCustomerScreeningResponseById(this.userId).subscribe((res: any) => {
      console.log("Review Flag :" +res?.response?.data?.reviewFlag);
      this.reviewFlag = res?.response?.data?.reviewFlag;
      this.screeningConfig = res?.response?.data?.screeningUserTypeConfiguration;
      // this.onboardedBy = res?.response?.data?.onboardedBy;
      console.log(this.screeningConfig);
      console.log(this.reviewFlag);
      console.log(this.permissions);
      if(this.permissions == "Maker Review" && this.reviewFlag == 0){
        console.log("Enable Initiate Review Button for maker");
        this.isInitiateKycFlag = true;
        this.saveReviewFlag = 1;
        this.isShowInitiate = false;
        
        
      }else if (this.permissions == "Maker Review" && this.reviewFlag == 1){
        console.log("Enable Submit Review Button for maker");
        this.isSubmittedKycFlag = true;
        this.saveReviewFlag = 2;
        this.isShowInitiate= true;
        this.saveFlag = true;

      }else if(this.permissions == "Checker Review" && this.reviewFlag == 2){
        console.log("Enable Initiate Review Button for maker");
        this.isInitiateKycFlag = true;
        this.saveReviewFlag = 3;
        this.isShowInitiate= false;
  
      }else if(this.permissions == "Checker Review" && this.reviewFlag == 3){
        console.log("Enable Submit Review Button for maker");
        this.isSubmittedKycFlag = true;
        this.saveReviewFlag = 4;
        this.isShowInitiate= true;
        this.saveFlag = true;
  
      }

      console.log(res?.response)
      this.fname = res?.response?.data?.fullName
      if(userType == "MERCHANT"){
        this.merchantFullName = res?.response?.data?.fullName;
      }
      // console.log("screeningId : "+res.response.data.data.data.idenfoId+" Fullname : "+res.response.data.data.data.firstName);
      this.getActivityTimeline(res?.response?.data?.screeningId);
      this.screeningId = res?.response?.data?.screeningId;
      // this.fullname =res?.response.data.fullName;
      // this.countryOfResidence = defaultCountry;
      
      // this.residenceStatus = "Rent";
      if(res?.response?.data?.data != null){

        if(res.response.data.data.data.accountInfo){
          this.deliveryChannel = res.response.data.data.data.accountInfo.registrationChannel[0].title;
          console.log("isSelfPepHit : "+res.response.data.data.data.isSelfPepHit);
          this.isSelfPepHit = res.response.data.data.data.isSelfPepHit;
        }
        if(res.response.data.data.data.kycSummary){
          this.sanctionHit = res.response.data.data.data.kycSummary.nameScreening.sanctionHit;
          this.pepHit = res.response.data.data.data.kycSummary.nameScreening.pepHit;
          this.adverseMediaHit = res.response.data.data.data.kycSummary.nameScreening.adverseMediaHit;
          this.riskRatingHit = res.response.data.data.data.kycSummary.riskRating;
          this.enforcementHit = res.response.data.data.data.kycSummary.enforcementHit;
        }
      }
       
     
      this.customerService.getCustomerNameScreeningById(this.screeningId).subscribe((res: any) => {
        console.log("Name Screening Remark : "+JSON.stringify(res.response.data));
        this.getSavedNameScreeningLength=res.response.data.length;
        console.log("Name Screening Remark Length : "+res.response.data.length);
        this.map = new Map();
        for(var i=0;i<res.response.data.length;i++){
          this.map.set(res.response.data[i].referenceId, res.response.data[i])    
        }
      });
      
      
      console.log("sanction Hit : "+this.sanctionHit);
      if(this.sanctionHit){
        this.sanctionHitClass = "feather icon-x-circle";
        this.sanctionHitColor = "color: red;"
      }else{
        this.sanctionHitClass = "feather icon-check";
        this.sanctionHitColor = "color: green;"
      }

      if(this.pepHit){
        this.pepHitClass = "feather icon-x-circle";
        this.pepHitColor= "color: red;"
      }else{
        this.pepHitClass = "feather icon-check";
        this.pepHitColor= "color: green;"
      }

      if(this.adverseMediaHit){
        this.adverseMediaHitClass = "feather icon-x-circle";
        this.adverseMediaHitColor= "color: red;"
      }else{
        this.adverseMediaHitClass = "feather icon-check";
        this.adverseMediaHitColor= "color: green;"
      }

      if(this.riskRatingHit=="sanction"){
        this.riskRatingHit = "Sanctioned";
        this.riskRatingHitClass = "feather icon-x-circle";
        this.riskRatingHitColor= "color: red;"
      }else{
        this.riskRatingHit = "Low";
        this.riskRatingHitClass = "feather icon-check";
        this.riskRatingHitColor= "color: green;"
      }

      if(this.enforcementHit){
        this.enforcementHitClass = "feather icon-x-circle";
        this.enforcementHitColor= "color: red;"
      }else{
        this.enforcementHitClass = "feather icon-check";
        this.enforcementHitColor= "color: green;"
      }

      if(this.isSelfPepHit == "low" || this.isSelfPepHit == "" || this.isSelfPepHit == undefined){
        this.isSelfPepHitClass = "feather icon-check";
        this.isSelfPepHitColor= "color: green;"
      }else{
        this.isSelfPepHitClass = "feather icon-x-circle";
        this.isSelfPepHitColor= "color: red;"
      }

      if(res?.response?.data?.data != null){
      console.log("Sanction Hit : "+this.sanctionHitColor+this.pepHit+this.adverseMediaHit+this.riskRatingHit);
      console.log(res.response.data.data.data.riskRatings);
      if(res.response.data.data.data.riskRatings && res.response.data.data.data.riskRatings.length>=18){
      this.countryOfResidenceScore = res.response.data.data.data.riskRatings[0].number;
      this.countryOfResidenceLevel = res.response.data.data.data.riskRatings[0].level+" Risk";
 
      this.deliveryChannelScore = res.response.data.data.data.riskRatings[3].number;
      this.deliveryChannelLevel = res.response.data.data.data.riskRatings[3].level+" Risk";

      this.industryScore = res.response.data.data.data.riskRatings[6].number;
      this.industryLevel = res.response.data.data.data.riskRatings[6].level+" Risk";

      this.nationalityScore = res.response.data.data.data.riskRatings[8].number;
      this.nationalityLevel = res.response.data.data.data.riskRatings[8].level+" Risk";

      this.productScore = res.response.data.data.data.riskRatings[10].number;
      this.productLevel = res.response.data.data.data.riskRatings[10].level+" Risk";

      this.stateScore = res.response.data.data.data.riskRatings[11].number;
      this.stateLevel = res.response.data.data.data.riskRatings[11].level+" Risk";

      this.suspiciousActivityReportsScore = res.response.data.data.data.riskRatings[12].overRideTo;
      this.suspiciousActivityReportsLevel = res.response.data.data.data.riskRatings[12].level+" Risk";

      this.nonResidentScore = res.response.data.data.data.riskRatings[13].overRideTo;
      this.nonResidentLevel = res.response.data.data.data.riskRatings[13].level+" Risk";

      this.residenceCountryIsSanctionedScore = res.response.data.data.data.riskRatings[14].overRideTo;
      this.residenceCountryIsSanctionedLevel = res.response.data.data.data.riskRatings[14].level+" Risk";

      this.suspiciousActivityReportsScore = res.response.data.data.data.riskRatings[12].overRideTo;
      this.suspiciousActivityReportsLevel = res.response.data.data.data.riskRatings[12].level+" Risk";

      this.sanctionScore = res.response.data.data.data.riskRatings[17].overRideTo;
      this.sanctionLevel = res.response.data.data.data.riskRatings[17].level+" Risk";

      if(this.sanctionScore == "sanction"){
        this.sanctionScore = "Sanctioned";
        this.sanctionLevel = "Sanctioned"
      }else{
        this.sanctionScore = "Low Risk";
        this.sanctionLevel = "Low Risk"
      }

      this.baseRatingLevel =  res.response.data.data.data.kycSummary.riskLevel+" Risk";

      this.overAllRating =  res.response.data.data.data.kycSummary.riskRating;
      if(this.overAllRating == "sanction"){
        this.overAllRating = "Sanctioned";
      }else{
        this.overAllRating = "Low Risk";
      }
    }
      
      console.log("length : "+res?.response?.data?.data?.data?.nameScreeningHits.length);

      this.nameScreeningHitsData = res?.response?.data?.data?.data?.nameScreeningHits;
      this.nameScreeningHitsLength = res?.response?.data?.data?.data?.nameScreeningHits.length;
      // console.log("Date of Birth : "+this.nameScreeningHitsData[0].screeningData.nationality[0]);
      }
      
    });
  }

  viewScreeningReport(){
    console.log("Clicked View Report :"+this.userId);
    this.customerService.getCustomerPdfById(this.userId)
      .subscribe((data:any) => {
        var reader = new FileReader();
        reader.readAsDataURL(data.body); 
        new Promise((resolve, reject) =>{ 
          reader.onloadend = function() {
            resolve(reader.result);                
          }
        }).then(data=>{
          this.image = data;
          // this.ScreeningReportEvent.emit(data);
          return this.modalReportComponent.open();  
        });
        })
  }

  downloadScreeningReport(){
    console.log("Clicked Download Report :"+this.userId);
            this.customerService.getCustomerPdfById(this.userId)
              .subscribe((data:any) => {
                console.log(data);
                var reader = new FileReader();
                reader.readAsDataURL(data.body); 
                new Promise((resolve, reject) =>{ 
                  reader.onloadend = function() {
                    resolve(reader.result);                
                  }
                }).then(data=>{
                  this.image = data;
                  this.downloadPdf(data,this.fname);
                });
                })
  }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }

    getCountryNames(data: any): string {
      const countries = data?.screeningData?.country;
      if (!countries || !Array.isArray(countries) || countries.length === 0) {
        return 'N/A';
      }
    
      const names = countries
        .map((c: any) => c?.name)
        .filter((name: string | null | undefined) => !!name);
    
      return names.length > 0 ? names.join(', ') : 'N/A';
    }

}